export default __webpack_public_path__ + "static/step3-49eeb015083adaddaa92bec5243738f1.jpg";